import DataProvider from "./data-provider";
import moment from "moment";


/**
 * A data provider for remote sourced data that should change every time.
 * that the table settings change, this assumes a default PagedResult response from apis
 */
export default class ApiDataProvider extends DataProvider
{
    /**
     *
     * @param {function} apiMethod The api function to use
     * @param {Array} apiArgs The args to provide the method
     */
    constructor(apiMethod, apiArgs)
    {
        super();
        this.apiMethod = apiMethod;
        this.apiArgs = apiArgs;
    }

    /**
     *
     * @param context The table context to convert to a querystring
     * @return {string} The querystring for the API to be passed
     */
    generateQueryFromContext(context) {
        const queryStringParams = [];

        const extractSettings = (settings) => {
            for(const param in settings)
            {
                const setting = settings[param];

         

                if(typeof(setting) === "undefined" || !setting || (typeof(setting) === "string" && setting.length === 0))
                { continue; }

                const value = (setting instanceof Date) ? moment(setting).format("YYYY/MM/DD") : setting;
                queryStringParams.push(`${encodeURIComponent(param)}=${encodeURIComponent(value)}`);
            }
        }

        extractSettings(context.sortSettings || {});
        extractSettings(context.filterSettings || {});
        extractSettings(context.filterSettings.advancedFiltersSelected || {});
        if(!context.isExporting)
        { extractSettings(context.pageSettings || {}); }

        return queryStringParams.join("&");
    }

    /**
     * Filters the array data as required
     * @param {any} context Contextual data required to return data
     * @return {Promise} returns a promise containing the data (elements field) and optional other fields
     */
    refreshData = (context) =>
    {


        const query = this.generateQueryFromContext(context);


        return this.apiMethod(...this.apiArgs, query).then(response => {
            return { elements: response.data, totalCount: response.paging.totalRecordCount, advancedFilters : response.advancedFilters };
        });
    }
}